var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"flex items-center gap-1",class:_vm.classes},[(_vm.isLate)?_c('i',{staticClass:"fas fa-exclamation-circle"}):_vm._e(),_vm._v(" "),_c('span',[_vm._v("\n        "+_vm._s(_vm.text)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }